
import { SET_ACTIVE_SEGMENT } from 'Store/constants';

const initialState = {
  activeSegment: null,
};

const segmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_SEGMENT:
      return {
        ...state,
        activeSegment: action.payload,
      };
    default:
      return state;
  }
};

export default segmentReducer;
